import WorkorderChecklistFooter from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistFooter';
import FutureServiceImportExcludedModal, {
  FutureServiceImportExludedValues,
} from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistFutureService/FutureServiceImportExcludedModal';
import ChecklistFutureServiceList from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistFutureService/FutureServiceList';
import ChecklistFutureServiceModalForm from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistFutureService/FutureServiceModalForm';
import FutureServiceToWorkorderModal from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistFutureService/FutureServiceToWorkorder';
import { useWorkorderChecklistContext } from '@/components/Movements/WorkOrders/WorkorderChecklist/WorkorderChecklistProvider';
import { WorkorderChecklistItemType } from '@/components/Movements/WorkOrders/WorkorderChecklist/WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import { DefaultRouteTabs } from '@/components/_common';
import {
  useWorkOrderChecklistFutureServiceImportExcludedServices,
  useWorkOrderChecklistFutureServiceToWorkorder,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { useWorkOrderItemsVerify } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { useDisclosure, useWindowSize } from '@/hooks';
import useChecklistValidRoutes from '@/hooks/useChecklistValidRoutes';
import { PageProps } from '@/types/PageProps';
import { Button, Col, Row, Typography } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

const WorkorderChecklistFutureServicesPage: React.FC<PageProps> = ({
  route,
}) => {
  const intl = useIntl();
  const { checklistItemId, checklistItemType, workorderId, boschChecklist } =
    useWorkorderChecklistContext();
  const [modalOpened, modalAction] = useDisclosure();
  const [modalServicesOpened, modalServicesAction] = useDisclosure();
  const [modalSendOpened, modalSendAction] = useDisclosure();
  const { isMobile } = useWindowSize();

  const { data: serviceData } = useWorkOrderItemsVerify(checklistItemId, true, {
    itemType: WorkOrderItemType.Service,
    enabled: checklistItemType === WorkorderChecklistItemType.Workorder,
  });
  const hasItems = !!serviceData?.data.length;

  const importFutureServiceExcluded =
    useWorkOrderChecklistFutureServiceImportExcludedServices();
  const sendFutureServiceToWorkorder =
    useWorkOrderChecklistFutureServiceToWorkorder();

  const routeParent = useChecklistValidRoutes({
    route,
    checklistItemType,
    workorderId,
    boschChecklist,
  });

  async function handleImport(values: FutureServiceImportExludedValues) {
    try {
      await importFutureServiceExcluded.mutateAsync({
        ids: values.itemIds,
        date: values.date,
      });

      modalServicesAction.close();
    } catch {}
  }

  async function handleSend(ids: number[]) {
    try {
      await sendFutureServiceToWorkorder.mutateAsync({
        workOrderComplementId: checklistItemId,
        ids,
      });

      modalSendAction.close();
    } catch {}
  }

  return (
    <DefaultRouteTabs
      route={routeParent}
      baseKey={String(checklistItemId)}
      basePath={`/app/movements/workorderChecklist/${checklistItemId}`}
      extra={
        <Button block type="primary" onClick={modalAction.open}>
          Cadastrar serviço
        </Button>
      }
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <Row
        gutter={[16, 16]}
        justify="space-between"
        style={{ marginBottom: 24 }}
      >
        <Col flex={1}>
          <Typography.Title level={4}>Serviços</Typography.Title>
        </Col>

        <Col span={isMobile ? 24 : undefined}>
          <Row gutter={[16, 16]}>
            {hasItems && (
              <Col span={24}>
                <Button block onClick={modalServicesAction.open}>
                  Importar serviços excluídos
                </Button>
              </Col>
            )}

            <Col span={24}>
              <Button block onClick={modalSendAction.open} ghost type="primary">
                Enviar para OS
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <ChecklistFutureServiceList />

      <WorkorderChecklistFooter />

      <ChecklistFutureServiceModalForm
        open={modalOpened}
        onCancel={modalAction.close}
      />

      <FutureServiceImportExcludedModal
        open={modalServicesOpened}
        onCancel={modalServicesAction.close}
        onOk={handleImport}
        items={serviceData?.data}
        confirmLoading={importFutureServiceExcluded.isLoading}
      />

      <FutureServiceToWorkorderModal
        open={modalSendOpened}
        onCancel={modalSendAction.close}
        onOk={handleSend}
        confirmLoading={sendFutureServiceToWorkorder.isLoading}
      />
    </DefaultRouteTabs>
  );
};

export default WorkorderChecklistFutureServicesPage;
